import { observable } from 'mobx';
import type { DepartmentResponseArgs } from '@this/domain/department/department2';
import Department, { convertDepartmentResponseToArgs } from '@this/domain/department/department2';

export type ApplicantResponseArgs = {
  foreign_approval_required?: boolean;
  domestic_approval_required?: boolean;
  department?: DepartmentResponseArgs | null;
};

export type ApplicantArgs = {
  foreignApprovalRequired?: boolean;
  domesticApprovalRequired?: boolean;
  department?: Department;
};

export const convertApplicantResponseToArgs = (response: ApplicantResponseArgs): ApplicantArgs => {
  return {
    foreignApprovalRequired: response.foreign_approval_required || false,
    domesticApprovalRequired: response.domestic_approval_required || false,
    department: response.department
      ? new Department(convertDepartmentResponseToArgs(response.department))
      : undefined
  };
};

export default class Applicant {
  @observable
  foreignApprovalRequired?: boolean;

  @observable
  domesticApprovalRequired?: boolean;

  @observable
  department?: Department;

  constructor(args: ApplicantArgs) {
    this.foreignApprovalRequired = args.foreignApprovalRequired || false;
    this.domesticApprovalRequired = args.domesticApprovalRequired || false;
    this.department = args.department;
  }
}
